import script from "./novoUsuario.vue?vue&type=script&setup=true&lang=js"
export * from "./novoUsuario.vue?vue&type=script&setup=true&lang=js"

import "./novoUsuario.vue?vue&type=style&index=0&id=95ebc80c&lang=css"

const __exports__ = script;

export default __exports__